import slugWithLocaleSchema from './slugWithLocaleSchema'

export default slugWithLocaleSchema
